
const numbersOnly = (cadena: string): string => {
  return cadena.replace(/[^0-9.,]/g, '');
}

export const cleanCharactersInString = (value: string): string => {
  const regex = /^[0-9.,]*$/;
  if (!regex.test(value)) {
    value = numbersOnly(value);
  }
  return value;
}